import { render } from "./Contact_index.vue?vue&type=template&id=51f33857&scoped=true"
import script from "./Contact_index.vue?vue&type=script&lang=js"
export * from "./Contact_index.vue?vue&type=script&lang=js"

import "./Contact_index.vue?vue&type=style&index=0&id=51f33857&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-51f33857"

export default script